import React, { useEffect, useState } from 'react';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import { store } from '../../../app/store';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
import CheckBoxHandler from '../../../UIComponents/CheckBoxHandler';
import CustomImage from '../../../UIComponents/CustomImage';
import CustomLink from '../../../UIComponents/CustomLink';
import FileUploadHandler from '../../../UIComponents/FileUploadHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
import RadioButtonHandler from '../../../UIComponents/RadioButtonHandler';
import TextareaHandler from '../../../UIComponents/TextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import Loader from '../../../UIComponents/Loader';

export default function Form({ is_edit, edit_id, Page = "" }) {
    const store_data = JSON.parse(store());
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const InitialData = {
        notice_title: "",
        notice_content: "",
        notice_date: ""
    }

    const [FormData, setFormData] = useState(InitialData);
    const [Editing, setEditing] = useState(is_edit);
    const [Error, setError] = useState([]);
    const [Loading, setLoading] = useState(true);

    const fetchSingleData = async (edit_id) => {
        const filter = { org_id: store_data?.org_id, id: edit_id }
        const response = await postAPI("/notice-board/fetchSingle", { ...filter, user: store_data });
        const NoticeBoardData = response?.data?.length > 0 ? response?.data[0] : {};
        if (response?.status == 1) {
            setFormData({
                id: NoticeBoardData["id"],
                notice_title: NoticeBoardData["notice_title"],
                notice_content: NoticeBoardData["notice_content"],
                notice_date: NoticeBoardData["notice_date"]
            });
            setLoading(false)
        } else {
            setFormData({});
        }
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanCreate(true);
                setCanEdit(true);
            } else {
                const createAllowed = await hasPermission("SETTINGS", "NoticeBoard", "CREATE");
                const editAllowed = await hasPermission("SETTINGS", "NoticeBoard", "EDIT");
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
            }
        };
        checkPermissions();

        setLoading(false)
        if (is_edit)
            fetchSingleData(edit_id)
    }, [is_edit, edit_id])


    const handleSubmit = async () => {
        setIsBTNClicked(true);
        if (IsBTNClicked) return;
        
        if (!isAdmin() && ((is_edit && !canEdit) || (!is_edit && !canCreate))) {
            toast.error('You do not have permission to perform this action.');
            setIsBTNClicked(false);
            return;
        }
        // Add validation logic
        let errors = [];
        if (!FormData.notice_title) errors.push('Title is required.');
        if (!FormData.notice_content) errors.push('Description is required.');
        if (!FormData.notice_date) errors.push('Date is required.');
        setError(errors);
        if (errors.length > 0) {
            toast.error('Please fix validation errors.');
            return;
        }
        const payload = { org_id: store_data?.org_id, ...FormData }
        const response = await postAPI(is_edit ? "/notice-board/update" : "/notice-board/create", { ...payload, user: store_data });
        if (response?.status == 1) {
            setIsBTNClicked(false);
            toast.success('New Notice Board Added Successfully.');
            window.location.reload()
        } else {
            setIsBTNClicked(false);
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }
    return (
        <>
            {
                Loading ?
                    <Loader />
                    :
                    (!isAdmin() && !canCreate && !canEdit) ? (
                        <div className="alert alert-danger">You do not have permission to access this form.</div>
                    ) : (
                        <FormSubmissionHandler handleSubmit={handleSubmit} editing={is_edit} error={Error} BTNLabel="Save" IsBTNClicked={IsBTNClicked}>
                            <div className="col-12 col-md-8">
                                <InputHandler form_data={FormData} setFormData={setFormData} Name="notice_title" Type="text" Label="Title" />
                            </div>
                            <div className="col-12 col-md-4">
                                <InputHandler form_data={FormData} setFormData={setFormData} Name="notice_date" Type="date" Label="Date" />
                            </div>
                            <div className="col-12 col-md-12 mt-2">
                                <NormalTextareaHandler form_data={FormData} setFormData={setFormData} Name="notice_content" Type="text" Label="Description" />
                            </div>
                            {Error.length > 0 && (
                                <div className="alert alert-danger">
                                    <ul>{Error.map((e, i) => <li key={i}>{e}</li>)}</ul>
                                </div>
                            )}
                        </FormSubmissionHandler>
                    )
            }
            <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
        </>
    )
}
